import { t } from "i18next";
import {
  isValidPhoneNumber,
  parsePhoneNumberWithError,
} from "libphonenumber-js";
import { z } from "zod";

export const AccountSettingSchema = () =>
  z.object({
    firstname: z.string().min(2, t("schemas.accountSettings.firstname.min")),
    lastname: z.string().min(2, t("schemas.accountSettings.lastname.min")),
    phone: z
      .string()
      .refine(isValidPhoneNumber, {
        message: t("schemas.accountSettings.phone.format"),
      })
      .transform((value) => parsePhoneNumberWithError(value).number.toString()),
    country: z.string(),
    state: z.string(),
    city: z.string(),
    occupation: z.string(),
    occupationId: z.number(),
  });

export type AccountSettingSchemaType = z.infer<
  ReturnType<typeof AccountSettingSchema>
>;
export type AccountFormFieldKey = keyof AccountSettingSchemaType;
